import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import Spotlight from '../../components/organisms/Spotlight';
import PediatricOccupationalTherapy from './component/PediatricOccupationalTherapy';
import Benefits from './component/Benefits';
import Conditions from './component/Conditions';
import TherapeuticListening from './component/TherapeuticListening';

const OccupationalTherapyPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Pediatric Occupational Therapy Wasilla Alaska | Guidepost OT Services
        </title>
        <meta
          name="description"
          content="Pediatric occupational therapy services in Wasilla, Alaska. Our OT specialists help children develop motor skills, sensory processing, and independence through play-based activities."
        />
        <meta
          name="keywords"
          content="pediatric occupational therapy Wasilla, OT services Alaska, sensory processing therapy, pediatric OT Wasilla, occupational therapy for children"
        />
      </Helmet>
      <HeroSection />
      <PediatricOccupationalTherapy />
      <Benefits />
      <Conditions />
      <TherapeuticListening />
      <Spotlight />
    </div>
  );
};

export default OccupationalTherapyPage;
